Flup.service("alert", function (flup) {
   var that = this;
   var _defaults = {
      allowOutsideClick: false,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      showCancelButton: false,
      buttonsStyling: false,
      confirmButtonClass: "btn btn-primary large-xs",
      cancelButtonClass: "btn btn-secondary large-xs btn-swal-margin",
   };

   function _alert(alertOpt) {
      return swal($.extend({}, _defaults, alertOpt));
   }

   function _getMessageTitle(type) {
      switch (type) {
         case "error":
            return "Ups!";
         case "success":
         default:
            return "Listo!";
      }
   }

   that.message = function (opt) {
      var html = opt.text;
      if (opt.description) {
         html += "<br><br><span>" + opt.description + "</span>";
      }
      var alertOpt = {
         html: html,
         title: opt.title === undefined ? _getMessageTitle(opt.type) : opt.title,
         type: opt.type || "success",
      };
      $.extend(alertOpt, opt.alertOpt||{});
      _alert(alertOpt).then(opt.onAccept || function () { }, opt.onCancel || function () { });
   }

   that.confirm = function (opt) {
      opt.type = opt.type || "question";
      opt.title = opt.title || "";
      opt.alertOpt = opt.alertOpt||{};
      opt.alertOpt.showCancelButton = true;
      that.message(opt);
   }

   that.loading = function(msg){
      swal({
         title: msg || "",
         text: "Aguarde un momento...",
         allowOutsideClick: false
     });
     swal.showLoading();
   }

   that.closeAll = function(){
      swal.close();
   }
});

Flup.init(function(flup){
   var initMessage = flup.config("alert").initMessage;
   if(initMessage) flup("alert").message(initMessage);
});